import React from 'react';
import styles from './index.module.sass';
import TrainingReportTable from './Table';
import moment from 'moment';

const TrainingReport = ({ currentTeam, isManager, isPlayerManager }) => {
  return (
    <div className={styles.training_report}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '1rem',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            paddingTop: '15px',
            gap: '12px',
          }}
        >
          <h2
            className={styles.training_report__info}
            style={{
              color: '#164162',
              fontWeight: '600',
            }}
          >
            Training Report
          </h2>
          <span
            style={{
              color: '#164162',
            }}
          >
            <span
              className={styles.statLabel}
              style={{
                opacity: '0.7',
              }}
            >
              Week:
            </span>
            <span
              className={styles.statLabel}
              style={{
                fontWeight: 600,
              }}
            >
              {' '}
              {moment().format('MMM DD, YYYY')}
            </span>
          </span>

          <TrainingReportTable
            teamId={currentTeam.id}
            isManager={isManager}
            isPlayerManager={isPlayerManager}
          />
        </div>
      </div>
    </div>
  );
};

export default TrainingReport;
